import axios from 'axios'

const instance = axios.create({
	baseURL: process.env.VUE_APP_API_BASE_URL
})

let isRefreshing = false
export const fetchJSONByGet = (url, params = {}, options = {}) => instance.get(url, {
	params,
	...options
})
export const fetchJSONByPost = (url, body = {}, options = {}) => instance.post(url, body, options)
export const fetchJSONByDel = (url, options = {}) => instance.delete(url, options)
export const fetchJSONByPut = (url, body = {}, options = {}) => instance.put(url, body, options)
export const fetchJSONByApis = function() {
	return Promise.all(Array.from(arguments))
}
/**
 * axios拦截器设置及全局加载提示
 * */
const buildHeaders = (config) => {
	config.headers['tenant-id'] = process.env.VUE_APP_TENANT_ID
	return {
		...config.headers
	}
}
const modifyPagable = (config) => {
	if (/get/i.test(config.method) && config.params) {
		const {
			current,
			size
		} = config.params
		if (current) {
			config.params['pageNo'] = current
			delete config.params['current']
		}
		if (size) {
			config.params['pageSize'] = size
			delete config.params['size']
		}
		delete config.params['pageSizes']
		delete config.params['total']
	}
	if (typeof(config.params) === 'object') {
		const keys = Object.keys(config.params)
		for (let i = 0; i < keys.length; i++) {
			const val = config.params[keys[i]]
			if (val === '') delete config.params[keys[i]]
		}
	}
	return config
}
const paramsSerializer = (config) => {
	if (config.params) {
		config.paramsSerializer = (params) => {
			var qs = require('qs');
			// {countryCodes: ['US', 'CN']} >>> countryCodes=US&countryCodes=CN
			return qs.stringify(params, {
				arrayFormat: 'repeat'
			})
		}
	}
}

function logRes(e) {
	if (!e.request.responseURL.includes('/admin-api') || process.env.NODE_ENV === "production") return
	const url = e.request.responseURL.split('/admin-api')[1].split('?')[0]
	try {
		console.log("%c ↑ API Header: " + url,
			"background: #010101; padding: 4px; color: #ffe300; border-radius: 4px; margin-bottom: 10px; border: 4px solid #c8c8c8",
			"\n", e.headers)
	} catch (e) {}
	try {
		Object.keys(e.config.params).length > 0 && console.log("%c ↑ API Request: " + url,
			"background: #93FFD8; padding: 4px; color: #146356; border-radius: 4px; margin-bottom: 10px; border: 4px solid #CFFFDC",
			"\n", e.config.params)
	} catch (e) {}
	try {
		console.log("%c ↓ API Response: " + url,
			"background: #CDDEFF; padding: 4px; color: #1C6DD0; border-radius: 4px; margin-bottom: 10px; border: 4px solid #A2D2FF",
			"\n", e.data)
	} catch (e) {}
}
// 请求拦截器
instance.interceptors.request.use((config) => {
	let headers = buildHeaders(config)
	modifyPagable(config)
	paramsSerializer(config)
	return {
		...config,
		headers
	}
}, (error) => {
	// 对请求错误做些什么
	return Promise.reject(error);
});
// 响应拦截器
instance.interceptors.response.use((response) => {
	// logRes(response)
	const {
		headers: {
			['content-type']: contentType
		},
		data
	} = response;
	if (/application\/json/.test(contentType) && data) {
		if (data.code === 0) {
			return data.data
		} else {
			return Promise.reject(data)
		}
	}
	return response;
}, (err) => {
	// 对响应错误做点什么
	try {
		return Promise.reject({
			code: err.response?.status || 500,
			data: null,
			msg: err.response?.data?.msg || err.response?.statusText
		})
	} catch (e) {}
	
	return Promise.reject(err)
})

